<template>
  <div class="container pt-24 flex justify-center items-center  gap-5 seconddiv">
    <div
      v-for="icon in icons"
      :key="icon.id"
      class="icon-box flex gap-2 items-center cursor-pointer"
      @click="goToBookingAssurance(icon.id)"
    >
      <img class="h-14" :src="icon.src" :alt="icon.alt" />
      <div class="flex flex-col">
        <span class="icon-box__title responsive-body-small font-bold whitespace-nowrap">
          {{ t(icon.title) }}
        </span>
        <span class="icon-box__subtitle responsive-body-small font-semibold text-bw-grey">
          {{ t(icon.subtitle) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { getAsset } from "@/helpers/assetsUtils";

const { t } = useI18n();
const router = useRouter();

function goToBookingAssurance(id: number) {
  router.push({ path: `/booking-assurance` });
}

const icons = [
  {
    id: 1,
    src: getAsset('homeSvg', 'secure.svg'),
    alt: 'Secure',
    title: 'iconbox.securePayment.title',
    subtitle: 'iconbox.securePayment.subtitle',
  },
  {
    id: 2,
    src: getAsset('homeSvg', 'compass.svg'),
    alt: 'Trusted',
    title: 'iconbox.trusted.title',
    subtitle: 'iconbox.trusted.subtitle',
  },
  {
    id: 3,
    src: getAsset('homeSvg', 'certified.svg'),
    alt: 'Certified',
    title: 'iconbox.certified.title',
    subtitle: 'iconbox.certified.subtitle',
  },
  {
    id: 4,
    src: getAsset('homeSvg', 'support.svg'),
    alt: 'Support',
    title: 'iconbox.support.title',
    subtitle: 'iconbox.support.subtitle',
  },
];
</script>

<style scoped>
.seconddiv {

  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 1440px) and (min-width: 1025px) {
  .seconddiv {
    width: 80%;
  }
}

@media (max-width: 1155px) and (min-width: 581px) {
  .seconddiv {
    width: 100%;
  }
}

@media (max-width: 1480px) {
  .seconddiv .icon-box {
    flex-direction: column;
  }

  .icon-box__title,
  .icon-box__subtitle {
    text-align: center;
  }

  .seconddiv img {
    width: 55px;
  }
}

@media (max-width: 768px) {
  .landingImage .booking__title {
    width: 85%;

  }
  .seconddiv img {
    width: 45px;
  }
  .curatedContainer .grid-container {
    display: flex !important;
    overflow-x: scroll;
  }

  .curatedContainer .grid-item {
    min-width: 260px;
    height: 300px;
  }


  .charterContainer > div > div {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }


  .bluediv > div {
    flex-direction: column;
    gap: 20px;
    padding: 30px 20px;
    height: 100%;
  }

  .textbox > .font-bold {
    font-size: 14px;
  }

  .textbox > .textBGgreen {
    font-size: 12px;
    width: 150px;
  }

}

@media (max-width: 1090px) {
.landingImage .booking__subtitle {
  display: none;
}

 .seconddiv {
  padding-top: 30px;
  padding-bottom: 30px;
 }

.seconddiv {
   flex-direction: column;
  align-items: center;
    row-gap: .65rem;
 }

 .seconddiv .icon-box {
   flex-direction: row;
   justify-content: unset !important;
   align-items: center;
   width: 100%;
  column-gap: 1rem;
}

.seconddiv .icon-box .icon-box__title,
.seconddiv .icon-box .icon-box__subtitle {
   text-align: inherit;
 }
}
</style>
